import { hsmBackendClient } from './client';
import { IControllerResponse, PlanPurchase } from './types';

export interface PostActivePlanInput {
  messageQty: number;
  renewalDate: string;
  updateRenewalDate: boolean;
}

/**
 * Contracts a new plan for the given company. Hits
 * `POST /company/{companyId}/active-plan` and returns the freshly
 * created `PlanPurchase`. The endpoint replaces the company's current
 * active plan and resets the consumption counter to zero — the caller
 * (the Plan form) is responsible for warning the admin.
 *
 * @param companyId Target company id.
 * @param input     Plan size, next renewal date and whether the
 *                  subscription's renewal date should be updated.
 */
export async function postActivePlan(
  companyId: string,
  input: PostActivePlanInput
): Promise<PlanPurchase> {
  const response = await hsmBackendClient.post<
    IControllerResponse<PlanPurchase>
  >(`/company/${encodeURIComponent(companyId)}/active-plan`, input);

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
